'use client'

import { useEffect, useRef, useState } from 'react'

import { SocialShare } from '@/app/components/SocialShare'
import { cn } from '@/app/utils/style'

interface GuideStickyShareProps {
  className?: string
  shareLabel: string
  shareOnPrefix: string
  linkCopiedLabel: string
}

export const GuideStickyShare = ({
  className,
  shareLabel,
  shareOnPrefix,
  linkCopiedLabel,
}: GuideStickyShareProps) => {
  const [isStuck, setIsStuck] = useState(false)
  const sentinelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const sentinel = sentinelRef.current
    if (!sentinel) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsStuck(!entry.isIntersecting)
      },
      { threshold: 0 },
    )

    observer.observe(sentinel)
    return () => observer.disconnect()
  }, [])

  return (
    <>
      {/* Sentinel element to detect when sticky activates */}
      <div ref={sentinelRef} className="h-0" />
      <div
        className={cn(
          'sticky bottom-0 flex justify-center bg-neutral-50',
          isStuck ? 'rounded-t-md' : 'rounded-md',
          className,
        )}
      >
        <SocialShare
          label={shareLabel}
          shareOnPrefix={shareOnPrefix}
          linkCopiedLabel={linkCopiedLabel}
        />
      </div>
    </>
  )
}
